// export const StandardViewBlockTimeline
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { InputGroup } from '@asd-stan/user/components/layout/input-group/input-group';
import moment from 'moment';

import {
	StandardDisplayField,
	StandardDisplayFieldHeader,
	StandardDisplayFieldValue,
	StandardDisplayFieldValueAbsent,
} from '../../single-standard.styled';

import { StyledENDataTabSection } from './enData-draft-tab-section.styled';

export const StandardViewBlockTimeline = ({
	data: { name, publicationDate, title },
}: {
	data: { name: string; publicationDate: Date | null; title: string };
}) => {
	const { t } = useTranslation();

	return (
		<InputGroup title={t('standard.createNWPea.timelineTitle')}>
			<StyledENDataTabSection>
				<StandardDisplayField>
					<StandardDisplayFieldHeader>
						{t('standard.singleStandardPage.enData.dateEa')}
					</StandardDisplayFieldHeader>
					{publicationDate ? (
						<StandardDisplayFieldValue>
							{moment(publicationDate).format('DD/MM/YYYY')}
						</StandardDisplayFieldValue>
					) : (
						<StandardDisplayFieldValueAbsent>
							{t('standard.singleStandardPage.enData.noDate')}
						</StandardDisplayFieldValueAbsent>
					)}
				</StandardDisplayField>
			</StyledENDataTabSection>
		</InputGroup>
	);
};
